import { Component, Input, OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ControlStockModel } from './controlstock.model';
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'convfact-controlstock-form',
    templateUrl: './controlstock-form.component.html',
    styleUrls: ['./controlstock.component.css'],
    standalone: false
})

export class ControlStockFormComponent implements OnInit {

  @Input() controlstock: ControlStockModel;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    public snackBar: MatSnackBar
  ) { }

  ready: boolean = false;

  ngOnInit() {
    this.ready = true;
  }

  save(controlStock: ControlStockModel): void {
    let noError = true;

    if (Utils.IsNullOrEmpty(this.controlstock.description)) {
      noError = false;
      this.displayInfo("El campo Descripcion es necesario");
    }

    if (Utils.IsNullOrEmptyNumber(this.controlstock.quantity)) {
      noError = false;
      this.displayInfo("El campo Cantidad es necesario");
    }

    if (noError) {
      this.onSave.emit(controlStock)
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }
}
